import { actionTypesEnum } from '../enum';

export const dashboardReducer = (state = null, action) => {

    if(action.type === actionTypesEnum.dashbord){
      return action.payload;
    }

     return state;
};
